var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.edf,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-selective_green',
                    to: 'to-golden_sand',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.alt)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl pb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleDescription.text)}}),_c('div',{staticClass:"container-components mb-4 lg:mb-8"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"-top-4 -right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Renaturation d’un ancien bras du Rhin sur l’île de Kembs'
                            ),
                        }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphOne_Title.text
                            )}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Part1_Content.text
                        )}}),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Part2_Content.text
                        )}}),_c('article-note',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage2.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage2.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],

                            verticalcontent:
                                _vm.currentPage.content.sParagraphTwo_Title
                                    .text,
                            content:
                                _vm.currentPage.content.sParagraphTwo_Part1_Content
                                    .text,
                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-4xl lg:text-3xl',
                                content: '',
                            },
                        }}}),_c('article-note',{attrs:{"options":{
                            content:
                                _vm.currentPage.content.sParagraphTwo_Part2_Content
                                    .text,

                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-4xl lg:text-3xl',
                                content: 'italic',
                            },
                        }}}),_c('article-note',{attrs:{"options":{
                            content:
                                _vm.currentPage.content.sParagraphTwo_Part3_Content
                                    .text,

                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-4xl lg:text-3xl',
                                content: '',
                            },
                        }}})],1),_c('div',{staticClass:"relative mb-4 lg:mb-8"},[_c('image-with-descriptions',{attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.oImage3.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.oImage3.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.oImage3.text,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}})],1),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative pt-8"},[_c('hotspot-richmedia',{staticClass:"-top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    "Le chantier de Romanche Gavet, un exemple d'ambition environnementale"
                                ),
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphThree_Title
                                    .text
                            )}})],1),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphThree_Content.text
                        )}}),_c('image-with-descriptions',{staticClass:"mt-2",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage4.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage4.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card"},[_c('article-note',{staticStyle:{"margin":"0","margin-bottom":"1.25rem"},attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage5.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage5.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                            verticalcontent:
                                _vm.currentPage.content.sParagraphFour_Title
                                    .text,
                            content:
                                _vm.currentPage.content.sParagraphFour_Content
                                    .text,
                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-4xl 2xl:text-3xl',
                                content: '',
                            },
                        }}}),_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Barrage de Livet : renaturation en végétal local'
                            ),
                        }}})],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }